const snakeCase = (str) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('_');

const createHazardList = (categoryLabel, categoryValue, items) => {
  return {
    label: categoryLabel,
    value: categoryValue,
    hazards: items.map((item) => ({
      label: item,
      value: `${categoryValue}__${snakeCase(item)}`,
      category: categoryValue,
    })),
  };
};

export const safetyAssetCategories = [
  createHazardList('Emergency Equipment', 'emergency_equipment', [
    'Fire Extinguisher',
    'Fire Blanket',
    'First Aid Kit',
    'Eyewash Station',
    'Emergency Shower',
    'Spill Kit',
    'Defibrillator (AED)',
    'Epi Pens',
    'Pumper',
    'Tanker',
  ]),
  createHazardList('Evacuation & Safety Points', 'evacuation_safety_points', [
    'Evacuation Point / Assembly Area',
    'Emergency Exit',
    'Muster Point',
    'Emergency Shelter',
  ]),
  createHazardList('Hazards & Risk Areas', 'hazards_risk_areas', [
    'Overhead Powerlines',
    'Chemical Storage',
    'Fuel Storage',
    'Machinery Zone',
    'Pesticide / Herbicide Area',
    'Water Body / Dams',
    'High Traffic Zone',
    'Slippery or Uneven Ground',
    'Confined Space',
    'Bee and Pollination Zones',
    'Fire Risk Zones',
    'Poisonous Animal Zones',
    'Biosecurity Checkpoints',
    'Stockpile Zones',
  ]),
  createHazardList('Roads', 'roads', [
    'Roadways',
    'Traffic Management plans',
    'Speed limits',
  ]),
  createHazardList('Access & Entry', 'access_entry', [
    'Access Point / Gate',
    'Entry Point',
    'No-Go Zone',
    'Visitor Check-in Point',
    'Loading Bay',
  ]),
  createHazardList('Resources & Infrastructure', 'resources_infrastructure', [
    'Water Access / Tank',
    'Electricity Isolation Point',
    'Fuel Access',
    'Emergency Contact Board',
    'Signage (General Safety Signs)',
    'Emergency Response Plans',
    'Hydrants',
  ]),
  createHazardList('Documentation & Training', 'documentation_training', [
    'Policy',
    'Procedure',
    'Safe Operating Procedures',
    'Induction',
    'Job Specific Training',
    'Risk Assessment',
    'Job Safety Analysis',
    'Permit to work',
    'Lock out Tag Out',
    'Safety Data Sheet (SDS) Location',
    'Other',
  ]),
];

export const allSafetyAssets = safetyAssetCategories.reduce(
  (acc, category) => [...acc, ...category.hazards],
  []
);

const safetyAssetMap = new Map(allSafetyAssets.map((asset) => [asset.value, asset]));

const safetyAssetCategoryMap = new Map(
  safetyAssetCategories.map((category) => [category.value, category])
);

export const getSafetyAsset = (value) => {
  if (!value) {
    return null;
  }
  return safetyAssetMap.get(value) ?? null;
};

export const getSafetyAssetLabel = (value) => {
  return getSafetyAsset(value)?.label ?? value;
};

export const getSafetyAssetCategoryValue = (value) => {
  const asset = getSafetyAsset(value);
  if (asset?.category) {
    return asset.category;
  }
  if (typeof value === 'string' && value.includes('__')) {
    return value.split('__')[0];
  }
  return null;
};

export const getSafetyAssetCategoryLabel = (value) => {
  return safetyAssetCategoryMap.get(value)?.label ?? value;
};

export const getSafetyAssetsForCategory = (categoryValue) => {
  if (!categoryValue) {
    return [];
  }
  return safetyAssetCategoryMap.get(categoryValue)?.hazards ?? [];
};
